import React, { Component } from "react";
import { dbType } from "../utils/fbdb";
import "./AddCategory.scss";
export default class AddCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: {
        species: "",
        name: "",
        gender: "male",
      },
    };
  }
  onChangeCate = (e) => {
    const { name, value } = e.target;
    this.setState({
      category: {
        ...this.state.category,
        [name]: value,
      },
    });
  };
  onSubmitValue = (e) => {
    e.preventDefault();
    dbType.push(this.state.category);
    this.setState({
      category: {
        species: "",
        name: "",
        gender: "male",
      },
    });
  };
  render() {
    return (
      <div className="flex-childBox">
        <h2 className="text-center">Add category</h2>
        <form onSubmit={this.onSubmitValue}>
          <label
            htmlFor="price"
            className="block text-sm font-medium text-gray-700"
          >
            Name
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <input
              value={this.state.category.name}
              type="text"
              name="name"
              id="name"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
              placeholder="Name"
              onChange={this.onChangeCate}
            />
          </div>
          {!this.state.category.name && (
            <span className="text-red">Please add!!!</span>
          )}
          <label
            htmlFor="price"
            className="block text-sm font-medium text-gray-700"
          >
            Gender
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <select
              value={this.state.category.gender}
              type="text"
              name="gender"
              id="gender"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
              placeholder="Gender"
              onChange={this.onChangeCate}
            >
              <option value="male">Male</option>
              <option value="female">female</option>
            </select>
          </div>
          {!this.state.category.gender && (
            <span className="text-red">Please add!!!</span>
          )}
          <label
            htmlFor="price"
            className="block text-sm font-medium text-gray-700"
          >
            Species
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <input
              value={this.state.category.species}
              type="text"
              name="species"
              id="species"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
              placeholder="Species"
              onChange={this.onChangeCate}
            />
          </div>
          {!this.state.category.species && (
            <span className="text-red">Please add!!!</span>
          )}
          <div className="text-center m-5">
            <button
              disabled={
                !this.state.category.species ||
                !this.state.category.name ||
                !this.state.category.gender
              }
              className="button_add_submit"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    );
  }
}
